import { NavLink, useLocation } from 'react-router-dom';

export default function ProgressSteps() {
    const { pathname } = useLocation();
    const steps = [
        { path: '/donar/informacion', name: 'Información' },
        { path: '/donar/pago', name: 'Pago' },
        { path: '/donar/confirmacion', name: 'Confirmación' }
    ];

    return (
        <div className="flex justify-between mb-8 px-4">
            {steps.map((step, index) => {
                const isActive = pathname === step.path;
                const isCompleted = steps.findIndex(s => s.path === pathname) > index;

                return (
                    <div key={step.path} className="flex flex-col items-center w-full">
                        <NavLink
                            to={step.path}
                            className={`w-8 h-8 rounded-full flex items-center justify-center 
                ${isActive || isCompleted ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`}
                        >
                            {isCompleted ? '✓' : index + 1}
                        </NavLink>
                        <span className={`text-sm mt-2 ${isActive ? 'font-bold text-blue-600' : 'text-gray-500'}`}>
                            {step.name}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}